<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Button from "$app/components/ButtonSpinner.svelte"
  import Navigation from "./Navigation.svelte"
  import { appStore } from "$app/store.svelte"

  import bg from "@images/onboarding/bg-eclipse.jpg"

  let { onUpdateStep, onUpdateUser } = $props()

  let errors = {}

  let saving = $state(false)
  async function updateUser() {
    saving = true
    errors = {}
    const formData = new FormData()
    formData.append("user[onboarding_steps][recognitions]", "true")
    try {
      const resp = await xhr.patch(
        `/user_onboarding/${appStore.current_user.id}`,
        formData
      )
      onUpdateUser(resp.data)
    } catch (e) {
      console.error(e.response)
      toast("There was an error", "error")
      if (e.response) {
        errors = { ...errors, ...e.response.data.errors }
      }
    } finally {
      saving = false
    }
  }
</script>

<div class="w-full">
  <div class="px-4 lg:px-6 pt-4 w-full pb-8 lg:pb-12 lg:text-left">
    <Navigation step="recognitions" {onUpdateStep} />
  </div>
  <div class="relative">
    <div class="mx-auto px-2 lg:px-6 w-full pb-6 lg:pb-12 lg:text-left">
      <div class="px-4 w-full lg:w-1/2 xl:w-5/12 xl:pr-16">
        <h2 class="text-3xl md:text-4xl font-bold text-left text-white">
          Recognitions
        </h2>

        <p class="mt-4 md:mt-6 text-lg md:text-xl text-white">
          Send a recognition to recognize another team member and help <span
            class="font-bold">build your team culture.</span
          >
        </p>
        <p class="mt-2 md:mt-6 text-lg text-white">
          Recognitions are immediately sent to the recipient. The following day
          the recognition will be sent to the whole team so they can be
          encouraged and share their reaction to it.
        </p>
        {#if appStore.role !== "recognition"}
          <p class="mt-2 md:mt-6 text-lg text-white">
            Recognitions are also included in the Weekly Report and on the
            Activity Page.
          </p>
        {/if}

        <div
          class="relative w-full block lg:hidden mt-4 md:mt-10 border border-gray-600"
        >
          <video playsinline autoplay loop muted preload="metadata">
            <source
              src="https://leadwithpurpose-web.s3.amazonaws.com/onboarding/recognitions.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div
          class="space-y-8 mt-4 lg:mt-8 max-w-md mx-auto flex justify-center"
        >
          <Button
            onclick={updateUser}
            processing={saving}
            class="btn-rounded bg-green-600 hover:bg-green-700 text-white btn-big w-full text-lg font-bold md:w-60 h-14"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
    <div
      class="hidden lg:inline-block lg:absolute lg:inset-y-0 lg:-right-0 lg:w-1/2 xl:w-7/12 lg:h-full bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
      style="background-image: url({bg});"
    >
      <div class="absolute inset-0 w-full p-2">
        <video
          autoplay
          playsinline
          loop
          muted
          preload="metadata"
          class="shadow-lg border border-gray-400"
        >
          <source
            src="https://leadwithpurpose-web.s3.amazonaws.com/onboarding/recognitions.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
</div>
